import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-56379e16"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "no-device-body"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "no-tips"
  }, "检测到设备断连，请检查设备是否正常连接！")], -1);
});
import { EnvCheckerService } from '@/services/env/checker.service';
import { useService } from '@kaokei/use-vue-service';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    var checkerService = useService(EnvCheckerService);
    return function (_ctx, _cache) {
      var _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        visible: _unref(checkerService).showDeviceDisconnect,
        "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
          return _unref(checkerService).showDeviceDisconnect = $event;
        }),
        closable: true,
        "destroy-on-close": true,
        "mask-closable": false,
        keyboard: false,
        width: 458,
        title: null,
        footer: null,
        centered: "",
        class: "no-device-dialog"
      }, {
        default: _withCtx(function () {
          return [_hoisted_1];
        }),
        _: 1
      }, 8, ["visible"]);
    };
  }
});